<template>
  <div class="font-list-item" :class="{ selected: selected }" @click="handleClick">
    <div class="content-cotnaienr">
      <span v-if="!isThumb" :style="normalStyle">{{ model.label }}</span>
      <img v-else :src="model.thumb" alt="缩略图" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { FontInfo } from '@/types';
  import { computed } from 'vue';

  type Props = {
    selected?: boolean;
  };

  /**
   * 使用 v-model，是为了下载完成后方便修改 item 的状态
   */
  const model = defineModel<FontInfo>({
    default: () => ({
      fontFamily: '',
      label: '默认文本',
      lang: 'en',
      apply: 'editor',
      path: '',
      type: 'system'
    })
  });

  withDefaults(defineProps<Props>(), {
    selected: false
  });

  const emit = defineEmits<{
    click: [FontInfo];
  }>();

  const isThumb = computed(() => {
    if (model.value.thumb) return true;
    return false;
  });

  const normalStyle = computed(() => {
    return {
      'font-family': model.value.fontFamily
    };
  });

  function handleClick() {
    // const { selected, ...fontData } = props;
    // const fontInfo: FontInfo = JSON.parse(JSON.stringify(fontData));

    emit('click', model.value);
  }
</script>

<style scoped>
  .font-list-item {
    width: 100%;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
  }

  .font-list-item:active {
    box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, 0.1);
  }

  .font-list-item:hover {
    background-color: #f1f5f9;
  }

  .font-list-item.selected {
    background-color: #fbf9ff;
  }

  .content-cotnaienr {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 20px;
    position: relative;
    box-sizing: border-box;
  }

  .content-cotnaienr span {
    font-size: 20px;
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    color: #374151;
  }

  .content-cotnaienr img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    object-position: center;
  }
</style>
